import axios from 'axios';
import { message } from "antd";
import Auth0 from "../../store/actions/auth/Auth";
import authActions from "../../store/actions/auth";

export const SET_USER_AUTH0_DATA = 'SET_USER_AUTH0_DATA';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_USER_SMSCODE = 'SET_USER_SMSCODE';
export const SET_SERVER_AUTH = 'SET_SERVER_AUTH';

export const serverLogout = async () => {
  try {
    await axios.post('/api/logout');
  } catch (err) {
    console.error('Could not clear server session on logout', err);
  }
};

export const actionCreators = {
  setSmsCode: (smsCode) => (dispatch) => {
    dispatch({
      type: SET_USER_SMSCODE,
      payload: smsCode,
    });
  },
  setAuth0ClientInfo: (clientInfo) => (dispatch) => {
    dispatch({
      type: SET_USER_AUTH0_DATA,
      payload: clientInfo,
    });
  },
  clearUserData: () => (dispatch) => {
    dispatch({ type: CLEAR_USER_DATA });
  },
  didSessionExpire: () => async (dispatch) => {
    try {
      const token = Auth0.getAccessToken();
      const result = Auth0.validateAccessToken(token);

      if (result === 13) {
        await message.error("Inloggningssessionen har gått ut. Försöker logga in igen...", 3);
        throw new Error('Session has been expired');
      }
    } catch (e) {
      await serverLogout();
      dispatch(authActions.signoutUser());
      dispatch(actionCreators.clearUserData());
      dispatch(authActions.signinUser());
    }
  },
  refreshSession: () => async (dispatch) => {
    try {
      dispatch({ type: SET_USER_LOADING, payload: true });

      await Auth0.refreshSession();
      dispatch(actionCreators.setAuth0ClientInfo(Auth0.getClientInfo()));
    } catch (err) {
      console.error("Error refreshing session: ", err);
    } finally {
      dispatch({ type: SET_USER_LOADING, payload: false })
    }
  },
  checkServerAuth: () => async (dispatch) => {
    try {
      const response = await axios.get('/api/authenticationCodeExists', {
        headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
      });
      dispatch({ type: SET_SERVER_AUTH, payload: response.data.mfaAuthCodeExists });
    } catch (err) {
      dispatch({ type: SET_SERVER_AUTH, payload: false });
    }
  },
}